export default __webpack_public_path__ + "static/media/jeremy-calendar.523c7405.svg";